import { EmailFormErrorJSON } from '../models/customer-reference-form';

export const formEmailErrors: EmailFormErrorJSON = {
    email: [
        {
            code: 'regex',
            message: 'Invalid email',
        },
        {
            code: 'required',
            message: 'Required field',
        },
    ],
};
